import { camelCase, lowerCase } from "lodash";

export function isObject(obj) {
    return obj && typeof obj === "object";
}

export function isArray(arr) {
    return arr instanceof Array;
}

export function isString(str) {
    return typeof str === "string";
}

export function isFunction(func) {
    return typeof func === "function";
}

export function isFormData(form) {
    return form instanceof FormData;
}

// 对象属性复制
export function objectAssign(dest, source) {
    if (Object.assign) {
        return Object.assign(dest, source);
    }
    for (var key in source) {
        dest[key] = source[key];
    }
    return dest;
}

// 获取url参数
export function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let result = location.search.substr(1).match(reg);
    return result ? unescape(result[2]) : "";
}

// 字符串去空格
export function strTrim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

// 判断是否是闰年
export function isLeap(year) {
    return (year % 100 !== 0 && year % 4 === 0) || year % 400 === 0;
}

// 字符串加0填充
export function padStartZero(str = "", len) {
    str = "" + str;
    let origLen = str.length;
    let diff = len - origLen;

    if (diff <= 0) {
        return str;
    }

    for (let i = 0; i < diff; ++i) {
        str = "0" + str;
    }

    return str;
}

// 递归处理数据
export function recursionTrans(datas = [], convert, subPropName, newSubPropName = subPropName) {
    return datas.map(function(data) {
        let newData = convert(data);

        if (isArray(data[subPropName])) {
            newData[newSubPropName] = recursionTrans(data[subPropName], convert, subPropName, newSubPropName);
        }

        return newData;
    });
}

// 过滤场景名 返回数组
export function filterTreeData(filterData, targetData) {
    let result = [],
        item,
        queue = [filterData];

    while ((item = queue.shift())) {
        item.forEach(key => {
            result.push(key.label);
            key.children && queue.push(key.children);
        });
    }
    return result.filter(function(items) {
        return items.indexOf(targetData) != -1;
    });
}

// 生成全局唯一的id
export function uniqueId() {
    let localTime = new Date().getTime();
    return localTime + Math.ceil(Math.random() * 10000);
}

// 根据keyName生成数组查找函数
export function genItemSearchHandler(keyName) {
    return function(items, key) {
        for (var i = 0; i < items.length; ++i) {
            if (items[i][keyName] == key) {
                return items[i];
            }
        }
        return null;
    };
}

// 根据keyName生成数组index查找函数
export function genIndexSearchHandler(keyName) {
    return function(items, key) {
        for (var i = 0; i < items.length; ++i) {
            if (items[i][keyName] == key) {
                return i;
            }
        }
        return null;
    };
}

//DOM处理
export function findParentNodeByCls(target, clsName) {
    while (target != window.document.body) {
        const cls = target.getAttribute("class");
        if (cls && cls.indexOf(clsName) !== -1) {
            return target;
        }
        target = target.parentNode;
    }

    return null;
}

// 节流函数
export function throttle(method, delay, duration) {
    let timer = null;
    let begin = new Date();

    return function() {
        let context = this,
            args = arguments;
        let current = new Date();
        clearTimeout(timer);
        if (current - begin >= duration) {
            method.apply(context, args);
            begin = current;
        } else {
            timer = setTimeout(function() {
                method.apply(context, args);
                begin = current;
            }, duration);
        }
    };
}

// 防抖函数
export function debounce(method, delay) {
    return function() {
        let context = this,
            args = arguments;
        clearTimeout(method.id);
        method.id = setTimeout(function() {
            method.call(context, args);
        }, delay);
    };
}

export function copyAttrIfExist(dest, sour, attrs) {
    attrs.forEach(function(attr) {
        typeof attr == "string" ? (dest[attr] = sour[attr]) : sour[attr.key] != null && (dest[attr.key] = sour[attr.key] || attr.default);
    });
}

// 动态加载资源
export function preLoadResouce(url, onloadCB) {
    var head = document.getElementsByTagName("head")[0];
    var element = document.createElement("script");
    element.type = "text/javascript";
    element.src = url;
    if (typeof onloadCB === "function") {
        element.onload = function() {
            element.onload = null;
            onloadCB();
        };
    }
    head.appendChild(element);
}

// 时间格式化
export function dateFormat(date, format = "YYYY-MM-DD hh:mm") {
    let ret = format.replace("YYYY", padStartZero(date.getFullYear(), 4));
    ret = ret.replace("MM", padStartZero(date.getMonth() + 1, 2));
    ret = ret.replace("DD", padStartZero(date.getDate(), 2));
    ret = ret.replace("hh", padStartZero(date.getHours(), 2));
    ret = ret.replace("mm", padStartZero(date.getMinutes(), 2));
    ret = ret.replace("ss", padStartZero(date.getSeconds(), 2));

    return ret;
}

// 获取n天的秒数
export function getDayMilliseconds(n = 1) {
    return n * 24 * 60 * 60 * 1000;
}

// 递归查找数据
export function recursionFind(datas = [], predcate, subPropName) {
    let ret = null;
    datas.some(function(data) {
        if (predcate(data)) {
            ret = data;
            return true;
        }

        if (isArray(data[subPropName])) {
            ret = recursionFind(data[subPropName], predcate, subPropName);

            return ret != null;
        }
    });

    return ret;
}

// 在光标处插入文字
export function insertAtCursor(obj, str) {
    if (document.selection) {
        var sel = document.selection.createRange();
        sel.text = str;
    } else if (typeof obj.selectionStart === "number" && typeof obj.selectionEnd === "number") {
        var startPos = obj.selectionStart,
            endPos = obj.selectionEnd,
            cursorPos = startPos,
            tmpStr = obj.value;
        obj.value = tmpStr.substring(0, startPos) + str + tmpStr.substring(endPos, tmpStr.length);
        cursorPos += str.length;
        obj.selectionStart = obj.selectionEnd = cursorPos;
    } else {
        obj.value += str;
    }
}

// dataURI 转换成Blob
export function dataURI2Blob(dataURI) {
    let byteStr = atob(dataURI.split(",")[1]);
    let mineType = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

    let arrayBuf = new ArrayBuffer(byteStr.length);
    let uintArr = new Uint8Array(arrayBuf);

    for (let i = 0; i < byteStr.length; ++i) {
        uintArr[i] = byteStr.charCodeAt(i);
    }

    return new Blob([arrayBuf], { type: mineType });
}

// 异步加载js文件
export function loadScript(url, onloadCB) {
    let head = document.getElementsByTagName("head")[0];
    let element = document.createElement("script");
    element.type = "text/javascript";
    element.src = url;

    if (typeof onloadCB === "function") {
        let hasLoaded = false;
        element.onload = function() {
            element.onload = null;
            !hasLoaded && onloadCB();
            hasLoaded = true;
            element.onreadystatechange = null;
        };
        element.onreadystatechange = function() {
            let r = element.readyState;
            if (r === "loaded" || r === "complete") {
                element.onreadystatechange = null;
                !hasLoaded && onloadCB();
                hasLoaded = true;
                element.onload = null;
            }
        };
    }

    head.appendChild(element);
}

export function delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 2 * 60 * 1000);
    let cval = getCookie(name);
    if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
}
export function getCookie(name) {
    let arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

// 电话验证
export function isMobile(telephone) {
    return /^1[3-9]\d{9}$/.test(telephone);
}

// 验证QQ号码
export function isQQ(QQNum) {
    return /^[1-9][0-9]{4,9}$/gim.test(QQNum);
}

// 是否是空值
export function isNoNull(value) {
    return !!value;
}

// 账号使用人名称规则 字母、数字
export function isUserName(value) {
    return /^[0-9a-zA-Z_]{6,12}$/.test(value);
}

// 邮箱规则
export function isEmail(value) {
    return /^[.0-9a-zA-Z_]{1,36}@([0-9a-zA-Z-]{1,13}\.){1,}[a-zA-Z]{1,3}$/.test(value);
}

// 验证非零正整数
export function noZeroInteger(value) {
    return /^\+?[1-9][0-9]*$/.test(value);
}

// 中文逗号转英文
export function commaConver(value) {
    return value.replace(/，/gi, ",");
}

// 数组去重
export function arrayDeduplicate(arr) {
    return [...new Set(arr)];
}

// 根据场景名递归查找数据
export function getParentTree(treeData, keywords) {
    let result = [];
    flatDataPath(treeData, "", result);
    return result.filter(item => item.label.indexOf(keywords) != -1)[0];
}

// 将多维场景数据转为一维，path
export function flatDataPath(arr, path, newData) {
    arr &&
        arr.forEach(item => {
            let str = path ? path + "/" + item.id : item.id;
            newData.push({
                path: str,
                label: item.label
            });
            if (item.children.length != 0) {
                flatDataPath(item.children, str, newData);
            }
        });
}

// 根据id递归执行相应函数，更新场景目录列表
export function updataTreeData(treeDatas, path, succfun, pathFunc) {
    treeDatas.some(function(treeNode) {
        if (treeNode.id === path[0] && path.length === 1) {
            succfun(treeNode);
            return true;
        } else if (treeNode.id === path[0]) {
            pathFunc && pathFunc(treeNode);
            updataTreeData(treeNode.children, path.slice(1), succfun, pathFunc);
            return true;
        }
    });
}

// 操作本地数据，封装
export const localStorage = {
    set: (name, content) => {
        if (!name) return;
        if (typeof content !== "string") {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    },
    get: name => {
        if (!name) return;
        return window.localStorage.getItem(name);
    },
    remove: name => {
        if (!name) return;
        window.localStorage.removeItem(name);
    }
};
// 移除对象中为空字符串的键值对
export function removeNullObj(obj) {
    let newObj = {};
    for (let i in obj) {
        if (obj[i]) {
            newObj[i] = obj[i];
        }
    }
    return newObj;
}

// 数据转换，tree转换成select组件需要的格式(不需返回一级)
export function sceneTree2Selector(arr) {
    let newData = [];
    arr &&
        arr.forEach(item => {
            flatData(item.children, item.label, newData);
        });
    return newData;
}

function flatData(arr, label, newData) {
    arr &&
        arr.forEach(item => {
            let str = label ? label + ">" + item.label : item.label;
            newData.push({
                label: str,
                value: item.id
            });
            if (item.children.length != 0) {
                flatData(item.children, str, newData);
            }
        });
    return newData;
}

/**
 * 对象递归下划线转驼峰
 * @param {} data
 * @param Boolean 是否翻转展示： false 下划线转驼峰 true 驼峰转下划线
 */
export function objCameCae(data, isReverse) {
    let newData;
    if (isArray(data)) {
        // 递归处理数组
        newData = [];
        data.forEach(value => {
            newData.push(objCameCae(value, isReverse));
        });
    } else if (isObject(data)) {
        // 递归处理obj
        const keys = Object.keys(data);
        newData = {};
        keys.forEach(key => {
            const newKey = isReverse ? lowerCase(key).replace(/\s/g, "_") : camelCase(key);
            newData[newKey] = objCameCae(data[key], isReverse);
        });
    } else {
        // 普通值
        return data;
    }

    return newData;
}

// 递归处理树节点过滤节点，复制生成一颗新树
export function filterTrees(treeDatas, predicate, childField = "children") {
    const filteredTree = [];
    for (let i = 0; i < treeDatas.length; ++i) {
        const treeNode = treeDatas[i];
        const isPersist = predicate(treeNode);
        if (isPersist) {
            const cloneNode = Object.assign({}, treeNode);
            filteredTree.push(cloneNode);
            if (cloneNode[childField]) {
                cloneNode[childField] = filterTrees(cloneNode[childField], predicate, childField);
            }
        }
    }
    return filteredTree;
}

/*
startTime: 开始计算时间
num 获取*天前的日期
*/
export function getDate(startTime = new Date(), num = 0, format = "YYYY-MM-DD hh:mm") {
    const day = 24 * 3600 * 1000;

    startTime.setTime(startTime.getTime() - num * day);
    const date = dateFormat(startTime, format);
    return date;
}

// export function copyText(text){
//     const input = document.createElement('input');
//     document.body.appendChild(input);
//     input.setAttribute('value', text);
//     input.select();
//     if (document.execCommand('copy')) {
//         document.execCommand('copy');
//     }
//     document.body.removeChild(input);
//   }
